import React from "react";
import { K } from "../theme";

// Structured-panel section header: a colored icon badge (defaults to the
// brand blue, but any widget can pass its own accent) plus a bottom divider
// that separates the header from the panel's content — the "clear
// panel/section" look enterprise dashboards (Zoho/Salesforce) use instead of
// a bare icon + label floating with no separation from what's below it.
export const Sec = ({ icon: Ic, title, color }) => {
  const c = color || K.p;
  return (
    <div className="flex items-center gap-[10px] mb-[14px] pb-[10px] border-b border-b0">
      {Ic && (
        <div className="flex items-center justify-center w-7 h-7 rounded-[9px] flex-shrink-0" style={{ background: `${c}17`, border: `1px solid ${c}2a` }}>
          <Ic size={14} color={c} />
        </div>
      )}
      <span className="text-[16px] font-extrabold text-t0 tracking-tight">{title}</span>
    </div>
  );
};
